// extracted by mini-css-extract-plugin
export var gif = "_cc-0";